<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Invoice" pageTitle="Invoice" />
            <InvoiceContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import InvoiceContent from '../Invoice/InvoiceContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'InvoicePage',
    components: {
        MainHeader,
        PageTitle,
        InvoiceContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>